/* Commit Circuit v11 motion. No framework; one rAF loop for scroll work. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  // Smooth scroll on desktop only (phones keep native momentum scrolling).
  if (!reduce && fine && window.Lenis) {
    var lenis = new window.Lenis({ lerp: 0.1 });
    (function raf(t) { lenis.raf(t); requestAnimationFrame(raf); })(0);
    document.querySelectorAll('a[href^="#"], a[href^="/#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href').split('#')[1];
        var el = id && document.getElementById(id);
        if (el && (location.pathname === '/' || a.getAttribute('href')[0] === '#')) { e.preventDefault(); lenis.scrollTo(el, { offset: -80 }); }
      });
    });
  }

  // Reveal: any [data-cc-reveal] gets .cc-in once it enters the screen.
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('cc-in'); io.unobserve(e.target); } });
  }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
  document.querySelectorAll('[data-cc-reveal]').forEach(function (el) { io.observe(el); });

  // Hero card stack: cycles every 3.2s, tilts toward the pointer on desktop.
  document.querySelectorAll('[data-cc-stack]').forEach(function (stack) {
    var cards = [].slice.call(stack.querySelectorAll('.cc-card'));
    if (cards.length < 2) return;
    var order = cards.map(function (_, i) { return i; });
    function paint() { order.forEach(function (ci, pos) { cards[ci].dataset.pos = pos < 3 ? pos : 2; cards[ci].style.zIndex = 3 - pos; }); }
    paint();
    var timer;
    function next() {
      var top = cards[order[0]];
      top.dataset.pos = 'out';
      setTimeout(function () { order.push(order.shift()); paint(); }, 420);
    }
    function start() { if (!reduce) timer = setInterval(next, 3200); }
    function stop() { clearInterval(timer); }
    start();
    new IntersectionObserver(function (es) { es[0].isIntersecting ? (stop(), start()) : stop(); }).observe(stack);
    if (fine && !reduce) {
      var inner = stack.querySelector('.cc-stack-inner');
      stack.addEventListener('pointermove', function (e) {
        var r = stack.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        inner.style.transform = 'rotateY(' + (x * 14) + 'deg) rotateX(' + (-y * 12) + 'deg)';
      });
      stack.addEventListener('pointerleave', function () { inner.style.transform = ''; });
    }
  });

  // Bento: click opens a modal with a dock of thumbnails (port of Finn's pick).
  document.querySelectorAll('[data-cc-bento]').forEach(function (root) {
    var items = [].slice.call(root.querySelectorAll('.cc-bento-item'));
    var modal = root.querySelector('.cc-modal'), stage = modal.querySelector('.cc-modal-stage'), dock = modal.querySelector('.cc-dock');
    var at = 0, lastFocus;
    items.forEach(function (it, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.setAttribute('aria-label', 'Show edit ' + (i + 1));
      b.style.setProperty('--r', (i % 2 ? 12 : -12) + 'deg');
      b.innerHTML = '<img alt="" loading="lazy" src="' + it.dataset.thumb + '">';
      b.addEventListener('click', function () { show(i); });
      dock.appendChild(b);
      it.addEventListener('click', function () { lastFocus = it; open(i); });
    });
    function show(i) {
      at = (i + items.length) % items.length;
      var it = items[at];
      stage.innerHTML = it.dataset.video
        ? '<video src="' + it.dataset.video + '" autoplay muted loop playsinline controls></video>'
        : '<img alt="' + (it.dataset.alt || '') + '" src="' + it.dataset.full + '">';
      [].forEach.call(dock.children, function (b, j) { b.classList.toggle('on', j === at); });
      var ord = modal.querySelector('.cc-modal-order');
      if (ord) { var base = ord.getAttribute('href').split('?')[0]; var pic = it.dataset.full || it.dataset.thumb; ord.href = pic ? base + '?style=' + encodeURIComponent(pic.split('&width')[0]) : base; }
      var on = dock.children[at]; if (on && on.scrollIntoView) on.scrollIntoView({ inline: 'center', block: 'nearest' });
    }
    function open(i) { modal.hidden = false; requestAnimationFrame(function () { modal.classList.add('open'); }); document.documentElement.style.overflow = 'hidden'; show(i); modal.querySelector('.cc-modal-x').focus(); }
    function close() { modal.classList.remove('open'); document.documentElement.style.overflow = ''; setTimeout(function () { modal.hidden = true; stage.innerHTML = ''; }, 300); if (lastFocus) lastFocus.focus(); }
    modal.querySelector('.cc-modal-x').addEventListener('click', close);
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    document.addEventListener('keydown', function (e) {
      if (modal.hidden) return;
      if (e.key === 'Escape') close(); if (e.key === 'ArrowRight') show(at + 1); if (e.key === 'ArrowLeft') show(at - 1);
    });
    // swipe on phones
    var sx = null;
    stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) { if (sx == null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) show(at + (dx < 0 ? 1 : -1)); sx = null; });
    // bento videos play only on screen
    var vio = new IntersectionObserver(function (es) { es.forEach(function (e) { e.isIntersecting ? e.target.play().catch(function () {}) : e.target.pause(); }); }, { rootMargin: '150px' });
    root.querySelectorAll('.cc-bento-item video').forEach(function (v) { vio.observe(v); });
  });

  // Instagram activity bubbles: pop up over the bento while it's on screen, rattle, counts climb.
  (function () {
    var layer = document.querySelector('[data-cc-ig]'), wrap = layer && layer.parentNode;
    if (!layer) return;
    var P = {
      like: '<path d="M12 21s-7.5-4.6-9.6-9.2C.8 8.3 2.9 4.5 6.6 4.5c2.1 0 3.6 1.2 5.4 3.1 1.8-1.9 3.3-3.1 5.4-3.1 3.7 0 5.8 3.8 4.2 7.3C19.5 16.4 12 21 12 21z"/>',
      comment: '<path d="M12 3C6.5 3 2 6.8 2 11.5c0 2.5 1.3 4.8 3.4 6.3L4.5 21l4-2c1.1.3 2.3.5 3.5.5 5.5 0 10-3.8 10-8.5S17.5 3 12 3z"/>',
      follow: '<path d="M12 12a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9zm0 2c-4.4 0-8 2.2-8 5v2h16v-2c0-2.8-3.6-5-8-5z"/>'
    };
    var phone = window.innerWidth < 900;
    // spots on the left/right edges: [side, top] in % of the gallery (desktop) or px under the header (phone)
    var spots = phone
      ? [['r', 20], ['l', 170], ['r', 330], ['l', 470]]
      : [['r', 6], ['l', 30], ['r', 56], ['l', 74], ['r', 32], ['l', 8]];
    var feed = [
      [['like', 450], ['comment', 99], ['follow', 84]], [['like', 2481]], [['comment', 312]], [['follow', 99]],
      [['like', 9870]], [['like', 1204], ['comment', 87], ['follow', 210]], [['follow', 318]], [['comment', 56]]
    ];
    var busy = {}, at = 0, si = 0, timer = null, max = phone ? 2 : 3;
    function fmt(n) { return n >= 10000 ? (n / 1000).toFixed(1).replace('.0', '') + 'K' : n.toLocaleString('en-US'); }
    function count(el, from, to, d) {
      var t0 = performance.now();
      (function f(t) { var p = Math.min(1, (t - t0) / d); el.textContent = fmt(Math.round(from + (to - from) * (1 - Math.pow(1 - p, 3)))); if (p < 1) requestAnimationFrame(f); })(t0);
    }
    function spawn() {
      if (layer.children.length >= max) return;
      var k = 0; while (busy[si % spots.length] && k++ < spots.length) si++;
      var idx = si++ % spots.length; if (busy[idx]) return; busy[idx] = 1;
      var parts = feed[at++ % feed.length], sp = spots[idx];
      var b = document.createElement('div');
      b.className = 'cc-ig-b from-' + sp[0] + (parts.length > 1 ? ' combo' : '');
      b.style[sp[0] === 'l' ? 'left' : 'right'] = phone ? '-4px' : '-34px'; b.style.top = phone ? sp[1] + 'px' : sp[1] + '%';
      b.innerHTML = '<div class="cc-ig-in">' + parts.map(function (q) { return '<span><svg viewBox="0 0 24 24">' + P[q[0]] + '</svg><b>' + fmt(Math.round(q[1] * 1.2)) + '</b></span>'; }).join('') + '</div>';
      layer.appendChild(b);
      var nums = [].slice.call(b.querySelectorAll('b')), vals = parts.map(function (q) { return q[1]; });
      nums.forEach(function (n, i) { count(n, 0, vals[i], 900); });
      // a few bumps: number jumps up and the bubble rattles
      var bumps = 0, bt = setInterval(function () {
        if (++bumps > 3) { clearInterval(bt); b.classList.add('out'); setTimeout(function () { b.remove(); busy[idx] = 0; }, 350); return; }
        nums.forEach(function (n, i) { var add = Math.max(1, Math.round(vals[i] * (0.02 + Math.random() * 0.05))); count(n, vals[i], vals[i] + add, 500); vals[i] += add; });
        b.classList.remove('rattle'); void b.offsetWidth; b.classList.add('rattle');
      }, 1300);
      setTimeout(function () { b.classList.add('rattle'); }, 560);
    }
    if (reduce) { spawn(); spawn(); return; }
    function start() { if (!timer) { spawn(); timer = setInterval(spawn, 1500); } }
    function stop() { clearInterval(timer); timer = null; }
    new IntersectionObserver(function (es) { es[0].isIntersecting ? start() : stop(); }, { threshold: 0.15 }).observe(wrap);
  })();

  // One scroll loop: steps progress, section rail, sticky order bar.
  var steps = document.querySelector('[data-cc-steps]');
  var stepEls = steps ? [].slice.call(steps.querySelectorAll('.cc-step')) : [];
  var line = steps && steps.querySelector('.cc-steps-line');
  var secs = [].slice.call(document.querySelectorAll('#main-content > .shopify-section')).filter(function (s) { return s.offsetHeight > 240; });
  var rail = document.querySelector('.cc-rail'), railNum = rail && rail.querySelector('.cc-rail-num'), ticks = [];
  if (rail && secs.length > 2) {
    rail.querySelector('.cc-rail-total').textContent = '/ ' + String(secs.length).padStart(2, '0');
    var tw = rail.querySelector('.cc-rail-ticks');
    secs.forEach(function () { var t = document.createElement('i'); tw.appendChild(t); ticks.push(t); });
  } else if (rail) { rail.remove(); rail = null; }
  var sticky = document.querySelector('.cc-sticky'), heroEl = document.querySelector('.cc-hero'), footer = document.querySelector('footer, .site-footer');
  var ticking = false;
  function onScroll() {
    var vh = innerHeight;
    if (steps) {
      var r = steps.querySelector('.cc-steps-list').getBoundingClientRect();
      var p = Math.min(1, Math.max(0, (vh * 0.6 - r.top) / r.height));
      if (line) line.style.setProperty('--p', (p * 100).toFixed(1) + '%');
      stepEls.forEach(function (s) { s.classList.toggle('on', s.getBoundingClientRect().top < vh * 0.62); });
    }
    if (rail && secs.length) {
      var cur = 0;
      secs.forEach(function (s, i) { if (s.getBoundingClientRect().top < vh * 0.5) cur = i; });
      railNum.textContent = String(cur + 1).padStart(2, '0');
      ticks.forEach(function (t, i) { t.classList.toggle('on', i === cur); });
    }
    if (sticky) {
      var past = heroEl ? heroEl.getBoundingClientRect().bottom < 0 : scrollY > vh;
      var nearEnd = footer ? footer.getBoundingClientRect().top < vh : false;
      sticky.classList.toggle('show', past && !nearEnd);
    }
    ticking = false;
  }
  addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  addEventListener('resize', onScroll);
  onScroll();
})();
